import * as ApiBase from '@/api/apiBase';
import AuthResponse from '@/models/authResponse';

export async function authenticate(username: string, password: string): Promise<AuthResponse> {
  const http = await ApiBase.createHttpRequest({ includeAuthorization: false });
  const result = await http.post('/authenticate', {
    username: username,
    password: password
  });
  return result.data;
}

export async function validate(): Promise<AuthResponse> {
  const http = await ApiBase.createHttpRequest();
  const result = await http.post('/validate', {});
  return result.data;
}